import login from './login'
import findPwd from './find-pwd'
import wxBind from './wx-bind'
import phoneBind from './phone-bind'

const user = [
  login,
  findPwd,
  wxBind,
  phoneBind
]

export default user
